import React from 'react';

/*
  A stat card, on the brand guide's 9.4 surface: white, a 1px edge, an 18px
  radius and 20 of padding, with the count in navy and its label under it.

  **The `cls` and `tc` props went on 11 September 2026**, job 27 phase 3. They
  painted the card and its number in a status colour, and the guide's card is
  white. `small` stays: count entry draws these at two sizes.
*/
export function StatCard({ num, label, small }) {
  return (
    <div className="stat-card" style={small ? { padding: 'var(--oh-space-3) var(--oh-space-4)' } : undefined}>
      <div className="sc-num" style={small ? { fontSize: 26 } : undefined}>{num}</div>
      <div className="sc-lbl">{label}</div>
    </div>
  );
}

// Pill rendered for an inventory_count.status value (header chip in CountEntry & LockedView).
export function StatusPill({ status }) {
  const map = {
    not_started: ['pill-ns',  'Not started'],
    in_progress:  ['pill-sub', 'In progress'],  // blue, and Submitted gold: guide 11.4, rebrand step 3
    submitted:    ['pill-ip',  'Submitted'],
    approved:     ['pill-app', 'Approved'],
  };
  const [cls, label] = map[status] || ['pill-ns', status];
  return <span className={'pill ' + cls}>{label}</span>;
}
